import { ENV } from '../settings/env';
import { extension } from '../services/url';

function getWebServiceHost(env, mobile = false) {
  let prefix;
  if (env === 'preProduction') {
    prefix = mobile ? 'm.preprod.' : 'preprod.';
  } else {
    prefix = mobile ? 'm.' : 'www.';
  }

  return `https://${prefix}dior.${extension}`;
}

export const webServiceHost = getWebServiceHost(ENV);
export const webServiceMobileHost = getWebServiceHost(ENV, true);



// WEBPACK FOOTER //
// ./src/services/dior.js